import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GridService } from '../shared/grid/grid.service';
import { LocationGroup } from '../models/locationGroup.model';

@Injectable({
    providedIn: 'root'
})
export class LocationGroupService extends GridService<LocationGroup> {

    constructor(http: HttpClient) {
        super('LocationGroup', http);
    }
}
